import Routes from "./Routes";
window.url = "https://mtorrent-back.vercel.app";
export default Routes;
